<template>
  <div class="view about">
    <section class="banner">
      <div class="banner-background">
        <img v-if="!isMobile" src="@/assets/cast_about_banner.png">
        <!-- <svg v-if="!isMobile" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1900" height="2413" viewBox="0 0 1900 2413"><defs><clipPath id="ahz-a"><rect width="1900" height="2413" fill="none"/></clipPath><clipPath id="ahz-b"><rect width="1900" height="2923" fill="#fff"/></clipPath><linearGradient id="ahz-c" x1="0.5" y1="1" x2="0.5" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#00a1ed"/><stop offset="0.994" stop-color="#0d988c"/></linearGradient><filter id="ahz-d" x="-463.427" y="-907.641" width="3161.17" height="3462.32" filterUnits="userSpaceOnUse"><feOffset dy="24" input="SourceAlpha"/><feGaussianBlur stdDeviation="48" result="e"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="e"/><feComposite in="SourceGraphic"/></filter><linearGradient id="ahz-f" y1="0" y2="1" xlink:href="#c"/><filter id="ahz-g" x="-619.553" y="-1583.431" width="3174.287" height="3495.131" filterUnits="userSpaceOnUse"><feOffset dy="24" input="SourceAlpha"/><feGaussianBlur stdDeviation="48" result="h"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="h"/><feComposite in="SourceGraphic"/></filter><linearGradient id="ahz-i" x1="1.223" y1="0.852" x2="-0.278" y2="0.5" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#00a1ed"/><stop offset="0.806" stop-color="#0d988c"/><stop offset="1" stop-color="#0d988c"/></linearGradient><filter id="ahz-j" x="55.705" y="1219.69" width="416.345" height="448.183" filterUnits="userSpaceOnUse"><feOffset dy="24" input="SourceAlpha"/><feGaussianBlur stdDeviation="48" result="k"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="k"/><feComposite in="SourceGraphic"/></filter><radialGradient id="ahz-l" cx="0.614" cy="0.356" r="0.817" gradientTransform="matrix(0.608, -0.238, 0.171, 1.113, 0.18, 0.106)" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#00a1ed"/><stop offset="0.942" stop-color="#0d988c"/><stop offset="1" stop-color="#0d988c"/></radialGradient><filter id="ahz-m" x="-263.203" y="1328.422" width="1339.151" height="946.48" filterUnits="userSpaceOnUse"><feOffset dy="24" input="SourceAlpha"/><feGaussianBlur stdDeviation="48" result="n"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="n"/><feComposite in="SourceGraphic"/></filter><linearGradient id="ahz-o" y1="1" x2="1.308" y2="-0.268" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#00a1ed"/><stop offset="0.641" stop-color="#0d988c"/><stop offset="1" stop-color="#0d988c"/></linearGradient><filter id="ahz-p" x="263.25" y="1262.564" width="337.955" height="332.787" filterUnits="userSpaceOnUse"><feOffset dy="24" input="SourceAlpha"/><feGaussianBlur stdDeviation="48" result="q"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="q"/><feComposite in="SourceGraphic"/></filter><filter id="ahz-r" x="778.743" y="702.777" width="151.612" height="154.287" filterUnits="userSpaceOnUse"><feOffset dy="14" input="SourceAlpha"/><feGaussianBlur stdDeviation="14" result="s"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="s"/><feComposite in="SourceGraphic"/></filter><filter id="ahz-t" x="795.686" y="875.514" width="127.706" height="127.892" filterUnits="userSpaceOnUse"><feOffset dy="14" input="SourceAlpha"/><feGaussianBlur stdDeviation="14" result="u"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="u"/><feComposite in="SourceGraphic"/></filter><filter id="ahz-v" x="945.21" y="815.127" width="105.16" height="106.313" filterUnits="userSpaceOnUse"><feOffset dy="14" input="SourceAlpha"/><feGaussianBlur stdDeviation="14" result="w"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="w"/><feComposite in="SourceGraphic"/></filter><filter id="ahz-x" x="1011.032" y="699.394" width="93.825" height="94.287" filterUnits="userSpaceOnUse"><feOffset dy="14" input="SourceAlpha"/><feGaussianBlur stdDeviation="14" result="y"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="y"/><feComposite in="SourceGraphic"/></filter><filter id="ahz-z" x="191.584" y="1946.196" width="149.888" height="149.592" filterUnits="userSpaceOnUse"><feOffset dy="14" input="SourceAlpha"/><feGaussianBlur stdDeviation="14" result="aa"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="aa"/><feComposite in="SourceGraphic"/></filter><filter id="ahz-ab" x="291.244" y="1912.39" width="113.958" height="114.555" filterUnits="userSpaceOnUse"><feOffset dy="14" input="SourceAlpha"/><feGaussianBlur stdDeviation="14" result="ac"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="ac"/><feComposite in="SourceGraphic"/></filter><filter id="ahz-ad" x="162.163" y="1805.867" width="104.789" height="104.661" filterUnits="userSpaceOnUse"><feOffset dy="14" input="SourceAlpha"/><feGaussianBlur stdDeviation="14" result="ae"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="ae"/><feComposite in="SourceGraphic"/></filter><filter id="ahz-af" x="152.147" y="1872.89" width="93.613" height="93.563" filterUnits="userSpaceOnUse"><feOffset dy="14" input="SourceAlpha"/><feGaussianBlur stdDeviation="14" result="ag"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="ag"/><feComposite in="SourceGraphic"/></filter><filter id="ahz-ah" x="795.636" y="1571.844" width="128.049" height="128.018" filterUnits="userSpaceOnUse"><feOffset dy="14" input="SourceAlpha"/><feGaussianBlur stdDeviation="14" result="ai"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="ai"/><feComposite in="SourceGraphic"/></filter><filter id="ahz-aj" x="723.599" y="1572.473" width="107.092" height="108.05" filterUnits="userSpaceOnUse"><feOffset dy="14" input="SourceAlpha"/><feGaussianBlur stdDeviation="14" result="ak"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="ak"/><feComposite in="SourceGraphic"/></filter></defs><g clip-path="url(#ahz-a)"><g clip-path="url(#ahz-b)"><g transform="translate(-319.427 -785.665)"><g transform="matrix(1, 0, 0, 1, 319.43, 785.66)" filter="url(#ahz-d)"><path d="M1735.8,1469.834c801.071-1146.3,737.631-181.658,847.943-588.588S1985.184-444.388,1115.421,254.532,84.084-4.717,0,495.8,934.723,2616.135,1735.8,1469.834Z" transform="matrix(-0.47, -0.88, 0.88, -0.47, 898.89, 2382.37)" fill="url(#ahz-c)"/></g></g><g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#ahz-g)"><path d="M1735.8,100.261c801.071,1146.3,738.149,196.646,886.792,587.37s-637.4,1326.851-1507.167,627.932S0,1544.949,0,1074.3,934.723-1046.04,1735.8,100.261Z" transform="translate(2148.21 -727.55) rotate(118)" fill="url(#ahz-f)"/></g><g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#ahz-j)"><path d="M512.025,1313.845c-31.809,14.957-83.609,71.97-80.156,109.668s62.158,56.082,93.967,41.125,36.722-63.254,33.269-100.952S543.834,1298.888,512.025,1313.845Z" transform="translate(-232 30.03)" fill="url(#ahz-i)"/></g><g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#ahz-m)"><path d="M-87.352,1633.883c100.183-185.3,134.88,309.151,462.555,91.266s673.576-7.1,518.57,110.453-389.993,496.915-663.461,398.031S-187.535,1819.184-87.352,1633.883Z" transform="translate(0 -143)" fill="url(#ahz-l)"/></g><g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#ahz-p)"><path d="M471.824,1434.115c0,10.8,12.989,27.8,25.477,32.318s24.474-3.429,24.474-14.227.5-22.674-11.988-27.2S471.824,1423.317,471.824,1434.115Z" transform="translate(-64.57 -40.38)" fill="url(#ahz-o)"/></g></g><g transform="translate(1645.113 -719.414) rotate(82)"><g transform="matrix(0.14, -0.99, 0.99, 0.14, 483.46, 1729.23)" filter="url(#ahz-r)"><path d="M30.607-.106C45.476-1.168,59.476,10.212,59.476,28.179s-14.614,31.03-31.769,33.9S0,50.391,0,32.425,15.738.955,30.607-.106Z" transform="translate(888.33 792.61) rotate(172)" fill="#00a1ed"/></g><g transform="matrix(0.14, -0.99, 0.99, 0.14, 483.46, 1729.23)" filter="url(#ahz-t)"><path d="M15.944.012C23.885-.3,31.526,5.468,31.766,14.256s-7.4,14.971-16.543,16.132S.245,24.277.005,15.489,8,.32,15.944.012Z" transform="translate(861.4 903.51) rotate(51)" fill="#00a1ed"/></g><g transform="matrix(0.14, -0.99, 0.99, 0.14, 483.46, 1729.23)" filter="url(#ahz-v)"><path d="M10.252.02c4.981-.315,9.67,3.06,9.67,8.387s-4.9,9.2-10.642,10.053S0,14.994,0,9.667,5.272.335,10.252.02Z" transform="matrix(0.14, 0.99, -0.99, 0.14, 1005.6, 843.13)" fill="#00a1ed"/></g><g transform="matrix(0.14, -0.99, 0.99, 0.14, 483.46, 1729.23)" filter="url(#ahz-x)"><ellipse cx="4.316" cy="4.587" rx="4.316" ry="4.587" transform="translate(1062.86 736.48) rotate(172)" fill="#00a1ed"/></g></g><g transform="matrix(0.766, -0.643, 0.643, 0.766, -1423.346, 2098.716)"><g transform="matrix(0.77, 0.64, -0.64, 0.77, 2439.37, -692.8)" filter="url(#ahz-z)"><path d="M23.4.052c11.365-.811,22.067,7.887,22.067,21.62S34.292,45.391,21.179,47.586,0,38.651,0,24.918,12.03.864,23.4.052Z" transform="matrix(0.64, 0.77, -0.77, 0.64, 270.25, 1974.2)" fill="#fff"/></g><g transform="matrix(0.77, 0.64, -0.64, 0.77, 2439.37, -692.8)" filter="url(#ahz-ab)"><path d="M12.187.009C18.257-.227,24.1,4.18,24.281,10.9S18.622,22.34,11.636,23.228.187,18.557,0,11.84,6.118.245,12.187.009Z" transform="translate(333.24 1963.35) rotate(-71)" fill="#fff"/></g><g transform="matrix(0.77, 0.64, -0.64, 0.77, 2439.37, -692.8)" filter="url(#ahz-ad)"><path d="M7.837.015c3.807-.241,7.392,2.339,7.392,6.411s-3.742,7.033-8.134,7.684S0,11.461,0,7.389,4.03.256,7.837.015Z" transform="matrix(0.77, -0.64, 0.64, 0.77, 204.16, 1843.66)" fill="#fff"/></g><g transform="matrix(0.77, 0.64, -0.64, 0.77, 2439.37, -692.8)" filter="url(#ahz-af)"><ellipse cx="3.299" cy="3.506" rx="3.299" ry="3.506" transform="matrix(0.64, 0.77, -0.77, 0.64, 199.52, 1900.89)" fill="#fff"/></g></g><g transform="matrix(-0.259, -0.966, 0.966, -0.259, 328.118, 3259.642)"><g transform="matrix(-0.26, 0.97, -0.97, -0.26, 3233.5, 526.72)" filter="url(#ahz-ah)"><path d="M15.944.012C23.885-.3,31.526,5.468,31.766,14.256s-7.4,14.971-16.543,16.132S.245,24.277.005,15.489,8,.32,15.944.012Z" transform="translate(860.49 1643.86) rotate(-136)" fill="#fff"/></g><g transform="matrix(-0.26, 0.97, -0.97, -0.26, 3233.5, 526.72)" filter="url(#ahz-aj)"><path d="M10.252.02c4.981-.315,9.67,3.06,9.67,8.387s-4.9,9.2-10.642,10.053S0,14.994,0,9.667,5.272.335,10.252.02Z" transform="translate(770.76 1624.52) rotate(-105)" fill="#fff"/></g></g></g></svg>
        <svg v-if="!isMobile" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1900" height="1407" viewBox="0 0 1900 1407"><defs><clipPath id="ahh-a"><rect width="1900" height="1407" fill="none"/></clipPath><linearGradient id="ahh-b" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#00a1ed"/><stop offset="0.994" stop-color="#0d988c"/></linearGradient><filter id="ahh-c" x="-619.553" y="-1583.431" width="3174.287" height="3495.131" filterUnits="userSpaceOnUse"><feOffset dy="24" input="SourceAlpha"/><feGaussianBlur stdDeviation="48" result="d"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="d"/><feComposite in="SourceGraphic"/></filter></defs><g clip-path="url(#ahh-a)"><g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#ahh-c)"><path d="M1735.8,100.261c801.071,1146.3,738.149,196.646,886.792,587.37s-637.4,1326.851-1507.167,627.932S0,1544.949,0,1074.3,934.723-1046.04,1735.8,100.261Z" transform="translate(2148.21 -727.55) rotate(118)" fill="url(#ahh-b)"/></g></g></svg> -->
      </div>
      <div class="wrapper">
        <div class="page-title">
          <svg v-if="!isMobile" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="209.637" height="211.483" viewBox="0 0 209.637 211.483"><defs><filter id="as-a" x="2.857" y="0" width="206.78" height="211.483" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="b"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="b"/><feComposite in="SourceGraphic"/></filter><filter id="as-c" x="0" y="67.036" width="75.371" height="75.371" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="d"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="d"/><feComposite in="SourceGraphic"/></filter><filter id="as-e" x="117.437" y="7.399" width="75.371" height="75.371" filterUnits="userSpaceOnUse"><feOffset dy="12" input="SourceAlpha"/><feGaussianBlur stdDeviation="9.5" result="f"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="f"/><feComposite in="SourceGraphic"/></filter></defs><g transform="matrix(-0.966, -0.259, 0.259, -0.966, 395.605, 582.548)"><g transform="matrix(-0.97, 0.26, -0.26, -0.97, 532.9, 460.31)" filter="url(#as-a)"><path d="M71.59-7.113C113.855-11.551,96.762,21.832,120,60s-3.5,74.168-54.793,54.457S-4.125,96.16,15.039,60,29.324-2.676,71.59-7.113Z" transform="matrix(-0.97, -0.26, 0.26, -0.97, 157.38, 165.69)" fill="#00a1ed"/></g><g transform="matrix(-0.97, 0.26, -0.26, -0.97, 532.9, 460.31)" filter="url(#as-c)"><circle cx="7.5" cy="7.5" r="7.5" transform="matrix(-0.97, -0.26, 0.26, -0.97, 42.99, 101.91)" fill="#00a1ed"/></g><g transform="matrix(-0.97, 0.26, -0.26, -0.97, 532.9, 460.31)" filter="url(#as-e)"><circle cx="7.5" cy="7.5" r="7.5" transform="matrix(-0.97, -0.26, 0.26, -0.97, 160.43, 42.27)" fill="#00a1ed"/></g></g></svg>
          <h1>About</h1>
          <p v-if="page">{{page.headline}}</p>
        </div>
      </div>
    </section>
    <section class="project">
      <div class="wrapper">
        <div class="project-section" v-if="page" v-html="page.description"></div>
        <div class="project-socials">
          <a href="https://twitter.com/CastnetworkE" target="_blank">
            <i class="fab fa-twitter"></i>
          </a>
          <a href="https://www.linkedin.com/showcase/cast-network-eu/about/" target="_blank">
            <i class="fab fa-linkedin"></i>
          </a>
          <div>Follow us</div>
        </div>
        <div class="project-section right" v-if="page">
          <p v-html="page.consortium.replace(/CAST/, '<b>CAST</b>')"></p>
        </div>
      </div>
    </section>
    <section class="support">
      <svg v-if="!isMobile" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="950" height="964" viewBox="0 0 950 964"><defs><clipPath id="ah3-a"><rect width="950" height="964" transform="translate(950 1506)" fill="none"/></clipPath><linearGradient id="ah3-b" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#00a1ed"/><stop offset="0.994" stop-color="#0d988c"/></linearGradient><filter id="ah3-c" x="-215.505" y="-246.309" width="1484.643" height="1428.234" filterUnits="userSpaceOnUse"><feOffset dy="24" input="SourceAlpha"/><feGaussianBlur stdDeviation="48" result="d"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="d"/><feComposite in="SourceGraphic"/></filter><pattern id="ah3-e" width="1" height="1" viewBox="306.072 0 935.232 840.417"><image preserveAspectRatio="xMidYMid slice" width="1260.625" height="840.417" :xlink:href="require('@/assets/shapes/about_h3-image.jpg')"/></pattern></defs><g transform="translate(-950 -1506)" clip-path="url(#ah3-a)"><g transform="translate(-130.979 -1548.965)"><g transform="matrix(1, 0, 0, 1, 1080.98, 3054.96)" filter="url(#ah3-c)"><path d="M884.522,346.375c194.331,591.764-213.2,654.275-738.767,280.538S690.192-245.389,884.522,346.375Z" transform="translate(-108.66 262.54) rotate(-29)" opacity="0.23" fill="url(#ah3-b)"/></g><path d="M389.034,794.055c0-21.432,15.15-43.651,35.888-43.651S475,772.623,475,794.055s-10.6,46.362-31.339,46.362S389.034,815.487,389.034,794.055ZM183.872,609.119C-150.3,558.878-3.856-.106,420.663,0S696.942,255.83,863.9,367.179,880,776.856,665.858,826.713c-21.788,5.073-40.677,7.381-57.376,7.381C461.061,834.1,484.042,654.249,183.872,609.119ZM871.209,336.051c-20.563-2.645-52.8-31.757-58.613-56.055s7.326-47.774,32.506-47.089,45.577,16.45,55.206,39.019c9.352,21.918-7.513,64.238-27.326,64.24A13.856,13.856,0,0,1,871.209,336.051Zm-75.6-111.539c-5.408-4.9-5.893-19.351.046-21.333s18.325,1.722,22.9,7.591,3.885,14-3.073,17.131a17.883,17.883,0,0,1-7.355,1.6A18.687,18.687,0,0,1,795.609,224.512Z" transform="translate(1151.524 3116.837)" fill="url(#ah3-e)"/></g></g></svg>
      <div class="wrapper">
        <div class="support-title">The project will provide a set of support actions for <b>Innovative Enterprises</b></div>
        <div class="services">
          <div class="service">
            <div class="service-logo" :style="{backgroundImage: `url(${require('@/assets/cast_ic_hackathon.svg')})`}"></div>
            <div class="service-name">Creative Tech <br>Tourism Hackathon</div>
          </div>
          <div class="service">
            <div class="service-logo" :style="{backgroundImage: `url(${require('@/assets/cast_ic_readiness.svg')})`}"></div>
            <div class="service-name">Investment <br>Readiness Workshops</div>
          </div>
          <div class="service">
            <div class="service-logo" :style="{backgroundImage: `url(${require('@/assets/cast_ic_forums.svg')})`}"></div>
            <div class="service-name">Investment <br>Forums</div>
          </div>
          <div class="service">
            <div class="service-logo" :style="{backgroundImage: `url(${require('@/assets/cast_ic_international.svg')})`}"></div>
            <div class="service-name">International Events - <br>Fusion of Creativity & Tourism</div>
          </div>
          <div class="service">
            <div class="service-logo" :style="{backgroundImage: `url(${require('@/assets/cast_ic_bootcamps.svg')})`}"></div>
            <div class="service-name">Regional <br>Bootcamps</div>
          </div>
          <div class="service">
            <div class="service-logo" :style="{backgroundImage: `url(${require('@/assets/cast_ic_incubation.svg')})`}"></div>
            <div class="service-name">SMEs Receiving <br>Incubation Support</div>
          </div>
        </div>
      </div>
    </section>
    <section class="development">
      <div class="development-intro">
        <p>The project will develop a manual highlighting good practice in gaining access to finance for enterprises in different sectors and at different stages of development. The following activities will be accomplished:</p>
      </div>
      <div class="investments">
        <div class="investment">
          <div class="investment-logo" :style="{backgroundImage: `url(${require('@/assets/cast_ic_pitches.svg')})`}"></div>
          <div class="investment-name">Investment <br>E-Pitches</div>
        </div>
        <div class="investment">
          <div class="investment-logo" :style="{backgroundImage: `url(${require('@/assets/cast_ic_challenges.svg')})`}"></div>
          <div class="investment-name">Location Challenges - <br>New Products, Services & Business Models</div>
        </div>
        <div class="investment">
          <div class="investment-logo" :style="{backgroundImage: `url(${require('@/assets/cast_ic_sme.svg')})`}"></div>
          <div class="investment-name">SMEs Supported in <br>Prototyping/NPD</div>
        </div>
        <div class="investment">
          <div class="investment-logo" :style="{backgroundImage: `url(${require('@/assets/cast_ic_mapping.svg')})`}"></div>
          <div class="investment-name">Mapping & Showcasing</div>
        </div>
        <div class="investment">
          <div class="investment-logo" :style="{backgroundImage: `url(${require('@/assets/cast_ic_networking.svg')})`}"></div>
          <div class="investment-name">Networking & Access <br>To New Markets</div>
        </div>
        <div class="investment">
          <div class="investment-logo" :style="{backgroundImage: `url(${require('@/assets/cast_ic_data.svg')})`}"></div>
          <div class="investment-name">Exploitation of Data Sets <br>And Data Analytics</div>
        </div>
      </div>
      <div class="development-content">
        <div class="development-shapes">
          <svg class="not-edge" v-if="!isMobile" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="575" height="890" viewBox="0 0 575 890"><defs><clipPath id="ap1-a"><rect width="575" height="890" transform="translate(0 4407)" fill="none"/></clipPath><radialGradient id="ap1-b" cx="0.38" cy="0.228" r="1.036" gradientTransform="translate(0.066 -0.067) scale(0.826 1.294)" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#00a1ed"/><stop offset="0.994" stop-color="#0d988c"/><stop offset="1" stop-color="#0d988c"/></radialGradient><pattern id="ap1-c" width="1" height="1" viewBox="144.9 262.185 518.427 522.408"><image preserveAspectRatio="xMidYMid slice" width="663.328" height="884.437" :xlink:href="require('@/assets/shapes/about_p1-image.jpg')"/></pattern><filter id="ap1-d" x="-226" y="111.141" width="759.328" height="764.421" filterUnits="userSpaceOnUse"><feOffset dy="16" input="SourceAlpha"/><feGaussianBlur stdDeviation="16" result="e"/><feFlood flood-opacity="0.161"/><feComposite operator="in" in2="e"/><feComposite in="SourceGraphic"/></filter><filter id="ap1-f" x="178.473" y="147.977" width="159.185" height="161.272" filterUnits="userSpaceOnUse"><feOffset dy="14" input="SourceAlpha"/><feGaussianBlur stdDeviation="14" result="g"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="g"/><feComposite in="SourceGraphic"/></filter><filter id="ap1-h" x="223.939" y="321.441" width="128.026" height="127.933" filterUnits="userSpaceOnUse"><feOffset dy="14" input="SourceAlpha"/><feGaussianBlur stdDeviation="14" result="i"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="i"/><feComposite in="SourceGraphic"/></filter><filter id="ap1-j" x="359.577" y="239.239" width="107.582" height="108.481" filterUnits="userSpaceOnUse"><feOffset dy="14" input="SourceAlpha"/><feGaussianBlur stdDeviation="14" result="k"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="k"/><feComposite in="SourceGraphic"/></filter><filter id="ap1-l" x="406.267" y="116.174" width="94.938" height="95.298" filterUnits="userSpaceOnUse"><feOffset dy="14" input="SourceAlpha"/><feGaussianBlur stdDeviation="14" result="m"/><feFlood flood-opacity="0.078"/><feComposite operator="in" in2="m"/><feComposite in="SourceGraphic"/></filter></defs><g transform="translate(0 -4407)" clip-path="url(#ap1-a)"><path d="M-6528.761,2668.739c-159.137,144.354,262.551,568.819,450.021,271.992S-6369.624,2524.386-6528.761,2668.739Z" transform="translate(6448.854 1798.903)" opacity="0.08" fill="url(#ap1-b)"/><g transform="matrix(1, 0, 0, 1, 0, 4407)" filter="url(#ap1-d)"><path d="M331.664,65.307C446.6,262.937,663.328,151.788,663.328,334.961S514.837,666.625,331.664,666.625,0,518.134,0,334.961,216.731-132.323,331.664,65.307Z" transform="translate(-178 144.94)" fill="url(#ap1-c)"/></g><g transform="translate(806.54 3030.893) rotate(73)"><g transform="matrix(0.29, -0.96, 0.96, 0.29, 1080.17, 1173.63)" filter="url(#ap1-f)"><path d="M30.607-.106C45.476-1.168,59.476,10.212,59.476,28.179s-14.614,31.03-31.769,33.9S0,50.391,0,32.425,15.738.955,30.607-.106Z" transform="translate(295.61 235.69) rotate(163)" fill="#00a1ed"/></g><g transform="matrix(0.29, -0.96, 0.96, 0.29, 1080.17, 1173.63)" filter="url(#ap1-h)"><path d="M15.944.012C23.885-.3,31.526,5.468,31.766,14.256s-7.4,14.971-16.543,16.132S.245,24.277.005,15.489,8,.32,15.944.012Z" transform="translate(286.35 349.44) rotate(42)" fill="#00a1ed"/></g><g transform="matrix(0.29, -0.96, 0.96, 0.29, 1080.17, 1173.63)" filter="url(#ap1-j)"><path d="M10.252.02c4.981-.315,9.67,3.06,9.67,8.387s-4.9,9.2-10.642,10.053S0,14.994,0,9.667,5.272.335,10.252.02Z" transform="translate(419.33 267.24) rotate(73)" fill="#00a1ed"/></g><g transform="matrix(0.29, -0.96, 0.96, 0.29, 1080.17, 1173.63)" filter="url(#ap1-l)"><ellipse cx="4.316" cy="4.587" rx="4.316" ry="4.587" transform="translate(459.2 152.95) rotate(163)" fill="#00a1ed"/></g></g></g></svg>
          <svg v-if="!isMobile" class="p2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="492" height="693" viewBox="0 0 492 693"><defs><clipPath id="ap2-a"><rect width="492" height="693" transform="translate(1408 4575)" fill="none"/></clipPath><pattern id="ap2-b" preserveAspectRatio="xMidYMid slice" width="100%" height="100%" viewBox="0 0 1950 1300"><image width="1950" height="1300" :xlink:href="require('@/assets/shapes/about_p2-image.jpg')"/></pattern><filter id="ap2-c" x="21" y="52.081" width="473.101" height="518.653" filterUnits="userSpaceOnUse"><feOffset dy="14" input="SourceAlpha"/><feGaussianBlur stdDeviation="14" result="d"/><feFlood flood-opacity="0.059"/><feComposite operator="in" in2="d"/><feComposite in="SourceGraphic"/></filter><linearGradient id="ap2-e" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#00a1ed"/><stop offset="0.994" stop-color="#0d988c"/></linearGradient></defs><g transform="translate(-1408 -4575)" clip-path="url(#ap2-a)"><g transform="matrix(1, 0, 0, 1, 1408, 4575)" filter="url(#ap2-c)"><path d="M2.845,125.792C71.221,36.258,175.019-41.261,259.034,62.648s119.4,269.743,62.419,345.545S110.787,439.6,31.1,365.854-65.532,215.326,2.845,125.792Z" transform="translate(102.83 67.16)" fill="url(#ap2-b)"/></g><path d="M17.329,3.347c7.58,2.216,16.278,17.832,16.488,26.984S24.269,41.12,18.171,39.954,3.673,30.3,3.5,21.465,9.75,1.131,17.329,3.347Z" transform="translate(1616.249 4570.558) rotate(30)" opacity="0.12" fill="url(#ap2-e)"/><path d="M26.439-5.006C37.632-5.976,44.032,14.1,39.86,28.807S19.063,52.043,9.754,53.823-8.986,46.9-4.912,32.687,15.246-4.036,26.439-5.006Z" transform="translate(1822.395 5218.05) rotate(-30)" opacity="0.12" fill="url(#ap2-e)"/><path d="M99.287,97.995c101.725-110.507,244.847-60.164,387.7,83.927S347.431,692.355,204.574,548.264-2.438,208.5,99.287,97.995Z" transform="translate(1828.093 4520.316) rotate(60)" opacity="0.12" fill="url(#ap2-e)"/></g></svg>
        </div>
        <div class="development-text" v-if="page" v-html="page.activities"></div>
        <!-- <p>The activities are directed at relevant stakeholders in the creative industry-tourism nexus. These include enterprises, sector organisations, regional organisations and business support bodies.</p>
        <p>The direct beneficiaries will be SMEs in the creative, cultural and tourist sectors, which will receive support from the project and will be enabled to develop their activities through start up and scale up processes, including innovation, access to new markets and finance.</p>
        <p>The indirect beneficiaries are the other groups, which will benefit from the models and techniques developed and can participate in networks resulting from the project.</p> -->
      </div>
    </section>
    <Newsletter />
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Newsletter from '../components/Newsletter'

export default {
  name: 'about',
  components: {
    Newsletter
  },
  computed: {
    ...mapGetters({
      isMobile: 'getMobile',
      db: 'getDb'
    })
  },
  data() {
    return {
      page: null
    }
  },
  mounted: function() {
    this.pageRef = this.db().collection('settings').doc('about').onSnapshot(page => {
      this.page = page.data()
      this.preloadImages([
        require('@/assets/cast_about_banner.png'),
        require('@/assets/shapes/about_h3-image.jpg'),
        require('@/assets/shapes/about_p1-image.jpg'),
        require('@/assets/shapes/about_p2-image.jpg'),
        require('@/assets/cast_about_image1@2x.png'),
        require('@/assets/cast_about_image2@2x.png'),
      ])
      .then(() => {
        this.$store.commit('setPageLoading', false)
      })
      .catch(() => {
        this.$store.commit('setPageLoading', false)
      })
    })
  },
  beforeDestroy: function() {
    if(this.pageRef) this.pageRef()
  }
}
</script>

<style scoped>
.about {
  padding-top: 236px;
  /* background: url(../assets/cast_about_banner.jpg) no-repeat top center/1920px auto; */
}

.banner .banner-background {
  position: absolute;
  top: 0;
  width: 1920px;
  left: 50%;
  transform: translateX(-50%);
}

.banner .banner-background svg,
.banner .banner-background img {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: auto;
}

.page-title {
  position: relative;
  display: flex;
  align-items: center;
  color: #fff;
  padding-left: 202px;
}

.page-title > svg {
  position: absolute;
  top: -70px;
  left: 105px;
}

.page-title h1 {
  position: relative;
  font: bold 3.21em/1 'Butler';
}

.page-title p {
  position: relative;
  margin-left: 196px;
  width: 664px;
  max-width: 100%;
}

.page-title p:before {
  content: '';
  position: absolute;
  display: block;
  top: 0;
  left: -136px;
  bottom: 0;
  width: 60px;
  height: 1px;
  margin: auto;
  background: currentColor;
}

section h2 {
  font: bold 3.21em/1 'Butler';
}

section h2:after {
  content: '';
  display: block;
  width: 74px;
  height: 1px;
  background: currentColor;
  margin-top: 20px;
}

.project {
  color: #fff;
  margin-top: 160px;
}

.project-section {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  font-size: 1.43em;
  font-weight: 300;
  line-height: 2;
}

.project-section:after {
  content: '';
  position: absolute;
  width: 33%;
  height: 472px;
  top: -115px;
  right: -95px;
  pointer-events: none;
  background: url(../assets/cast_about_image1@2x.png) no-repeat center/contain;
}

.project-section.right:after {
  right: auto;
  left: -105px;
  top: -264px;
  width: 42.35%;
  height: 573px;
  background-image: url(../assets/cast_about_image2@2x.png);
}

.project-section:first-child >>> p {
  margin-left: 136px;
  height: 240px;
}

.project-section.right {
  height: 280px;
  margin-top: 82px;
  align-items: flex-end;
}

.project-section >>> p {
  width: 60%;
}

.project-socials {
  margin-top: 206px;
  text-align: right;
  letter-spacing: .58em;
}

.project-socials a {
  font-size: .85rem;
  margin-left: 16px;
  color: #fff;
}

.project-socials div {
  font-size: .72rem;
  text-transform: uppercase;
}

.support {
  position: relative;
  margin-top: 178px;
  /* background: url(../assets/cast_about_support.png) no-repeat top right/47.55% auto; */
  padding-top: 200px;
}

.support > svg {
  position: absolute;
  top: 72px;
  right: 0;
  max-width: 50%;
}

.support .support-title {
  width: 256px;
  font-size: 2.5em;
  line-height: 1.06;
  color: #fff;
  margin-left: 130px;
}

.services {
  margin-top: 305px;
}

.services .service {
  display: flex;
  align-items: center;
  font: bold 1.8em/1.1875 'Butler';
  color: #0D988C;
  margin-bottom: -48px;
  white-space: nowrap;
}

.services .service:last-child {
  margin-bottom: 0;
}

.services .service:nth-child(2) {
  margin-left: 544px;
}

.services .service:nth-child(3) {
  margin-left: 50px;
}

.services .service:nth-child(4) {
  margin-left: 594px;
}

.services .service:nth-child(5) {
  margin-left: 100px;
}

.services .service:nth-child(6) {
  margin-left: 644px;
}

.services .service .service-logo,
.investment .investment-logo {
  width: 128px;
  height: 128px;
  flex-shrink: 0;
  border-radius: 50%;
  box-shadow: 0 12px 24px rgba(0,0,0,.06);
  margin-right: -23px;
  background: #fff url(../assets/cast_ic_image.svg) no-repeat center/28% 28%;
}

.development {
  color: #343434;
  /* background: url(../assets/cast_about_content2.png) no-repeat right bottom/28.95% auto; */
  margin-bottom: -180px;
}

.development .development-intro {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  height: 333px;
  background: url(../assets/cast_about_development.svg) no-repeat center/1920px auto;
}

.development .development-intro p,
.development .development-content p,
.development .development-content .development-text >>> p {
  width: 800px;
  max-width: 100%;
  font-size: 1.43em;
  font-weight: 300;
  line-height: 2;
}

.development .development-intro p {
  font-size: 1.2em;
}

.development .investments {
  width: 1144px;
  max-width: 100%;
  margin: auto;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}

.development .investments .investment {
  width: 33.3333333%;
  margin: 0 0 32px;
  text-align: center;
}

.development .investments .investment .investment-logo {
  margin: 0 auto;
}

.development .investments .investment .investment-name {
  font-size: 1.2em;
  line-height: 1.5;
  font-weight: bold;
  padding: 0 16px;
  color: #0D988C;
  margin: 32px -32px 0;
}

.development .development-content {
  position: relative;
  padding-top: 44px;
  padding-bottom: 286px;
  margin-top: 44px;
}

#app[edge] .development .development-content {
  background: url(../assets/cast_about_content1.png) no-repeat top left/26.66% auto;
}

.development .development-content p:last-child,
.development .development-content .development-text >>> p:last-child {
  width: 41.66%;
}

.development .development-content .development-shapes svg {
  position: absolute;
  top: 0;
  left: 0;
  width: 30%;
}

.development .development-content .development-shapes svg.p2 {
  left: auto;
  top: auto;
  height: auto;
  right: 0;
  bottom: 0;
  width: 28.95%;
}

.development .development-content p,
.development .development-content .development-text >>> p {
  margin: 70px 0 0 calc(26.66% + 30px);
  max-width: calc(73.33% - 54px);
}

.development .development-content .development-text >>> img {
  display: block;
  width: 100%;
}

.development .development-content p:first-child,
.development .development-content .development-text >>> p:first-child {
  margin-top: 0;
}

@media screen and (max-width: 1310px) {
  .services .service .service-logo {
    width: 196px;
    height: 196px;
  }
  .services .service {
    font-size: 1.9em;
  }
  .support {
    padding-top: 12%;
  }
  .support .support-title {
    margin-left: 10.5%;
  }
}

@media screen and (max-width: 1170px) {
  .support {
    padding-top: 10%;
  }
  .services .service:nth-child(2) {
    margin-left: 394px;
  }
  .services .service:nth-child(4) {
    margin-left: 444px;
  }
  .services .service:nth-child(6) {
    margin-left: 494px;
  }
}

@media screen and (max-width: 1024px) {
  .project,
  .page-title {
    color: #343434;
  }
  .page-title {
    display: block;
    padding: 0;
    text-align: center;
  }
  .page-title h1 {
    color: #00A1ED;
    height: 32px;
  }
  .page-title p {
    width: 420px;
    margin: auto;
  }
  .page-title p:before {
    position: relative;
    display: block;
    left: auto;
    margin: 16px auto 24px;
    background: #00A1ED;
  }
  .project-section:first-child >>> p {
    width: 75%;
    margin: 0;
    height: auto;
  }
  .project-section {
    font-size: 18px;
    line-height: 1.77;
  }
  .project-section.right {
    height: auto;
    min-height: 370px;
    margin: 0;
  }
  .project-socials {
    margin: 82px 0;
    text-align: center;
    color: #00A1ED;
  }
  .project-socials a {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid rgba(0, 162, 237, 0.5);
    font-size: 20px;
    margin: 0 6px;
    color: #00A1ED;
  }
  .project-socials a i {
    margin-left: 8px;
  }
  .project-socials div {
    font-size: 10px;
    margin-top: 8px;
  }
  .project {
    position: relative;
    overflow: hidden;
    margin-top: 72px;
    padding-top: 5%;
  }
  .project-section.right:after {
    top: -124px;
  }
  .project-section.right >>> p {
    width: 66%;
  }
  .support {
    padding-top: 0;
    margin-top: 72px;
  }
  .support .support-title {
    font-size: 32px;
    width: 642px;
    max-width: 100%;
    background: url(../assets/cast_m_about_innovation.svg) no-repeat center/cover;
    margin: 0 auto;
    padding: 80px 78px 100px 122px;
  }
  .services {
    display: flex;
    flex-flow: row wrap;
    width: 800px;
    max-width: 100%;
    margin: 72px auto 0;
  }
  .services .service {
    width: 50%;
    margin: 16px 0 !important;
    font-size: 21px;
    white-space: normal;
    padding: 0 8px;
  }
  .services .service .service-logo {
    width: 128px;
    height: 128px;
    margin-right: -24px;
  }
  .development .development-intro {
    padding: 48px;
    height: auto;
    margin: 72px 0;
    background-size: auto 180%;
  }
  .investment .investment-logo {
    width: 196px;
    height: 196px;
  }
  .development .investments .investment .investment-name {
    font-size: 16px;
    margin: 32px 0 0;
  }
  .development .development-content {
    padding-top: 0;
    margin-top: 72px;
    padding-bottom: 140px;
  }
  .development .development-content p,
  .development .development-content .development-text >>> p {
    margin: 0 auto 48px;
    font-size: 18px;
    line-height: 1.77;
    max-width: calc(100% - 48px);
  }
  .development .development-content p:last-child,
  .development .development-content .development-text >>> p:last-child {
    width: 800px;
    margin-bottom: 0;
  }
  #app[edge] .development .development-content {
    background: none;
  }
  .development .development-content:before,
  .development .development-content:after {
    content: '';
    display: block;
    height: 100vw;
    max-height: 565px;
    box-sizing: unset;
    background: url(../assets/cast_about_content1.png) no-repeat center left/contain;
  }
  .development .development-content:after {
    background-image: url(../assets/cast_about_content2.png);
    background-position: center right;
    max-height: 365px;
    margin-top: -40px;
  }
}

@media screen and (max-width: 760px) {
  .project-section:after {
    top: 100%;
    width: 324px;
    height: 324px;
    margin-top: 24px;
  }
  .project-section.right {
    min-height: 0;
  }
  .project-section.right:after {
    top: auto;
    bottom: 100%;
    margin-bottom: 32px;
    width: 324px;
    height: 324px;
  }
  .project-section:first-child >>> p,
  .project-section.right >>> p {
    width: auto;
  }
  .project-socials {
    position: relative;
    margin: 324px 0;
    z-index: 1;
  }
  .services .service {
    flex-flow: column nowrap;
    text-align: center;
  }
  .services .service .service-logo {
    margin: 0 auto 16px;
  }
  .development .investments .investment {
    width: 50%;
  }
  .development .investments .investment .investment-name {
    font-family: 'Butler';
    font-size: 21px;
  }
  .development .development-intro p {
    font-size: 18px;
    line-height: 1.77;
  }
}

@media screen and (max-width: 704px) {
  .about {
    padding-top: 172px;
  }
  .support .support-title {
    margin: 0 -24px;
    width: auto;
    max-width: none;
    padding: 88px 12% 114px 16%;
  }
}

@media screen and (max-width: 580px) {
  .services {
    margin: 72px -16px 0;
    width: auto;
    max-width: none;
  }
  .services .service {
    font-size: 16px;
  }
  .investment .investment-logo {
    width: 128px;
    height: 128px;
  }
  .development .investments .investment .investment-name {
    font-size: 14px;
  }
}

@media screen and (max-width: 400px) {
  .development .development-intro {
    padding: 48px 24px;
  }
  .development .development-intro p {
    font-size: 16px;
  }
  .support .support-title {
    padding: 68px 12% 64px 16%;
    font-size: 20px;
  }
}
</style>

